











 










const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgMemberRow_organization",
  "selections": [
    {
      "alias": "isViewerBillingLeader",
      "args": null,
      "kind": "ScalarField",
      "name": "isBillingLeader",
      "storageKey": null
    },
    {
      "alias": "orgId",
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BillingLeaderActionMenu_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node ).hash = "6020f285f7293164a4647ec70f68867e";

export default node;
